import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../pages/dashboard/Dashboard";

import FlightReportDetail from "../pages/flightReport/FlightReportDetail";
import NotFound from "../pages/notFound/NotFound";
import Toast from "./Toast/toast";
import HeaderBar, { IHeaderBarLink } from "./HeaderBar";
import { useAuth } from "react-oidc-context";
import { LoggedOut } from "../pages/loggedOut/LoggedOut";
import { ProtectedRoute } from "../utils/ProtectedRoute";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ILayoutProps {}

const Layout: React.FunctionComponent<ILayoutProps> = (props) => {
    const location = useLocation();
    const [isBackground, setBackground] = React.useState(false);
    const auth = useAuth();
    const headerTitle = "Flight Reports";
    const logoUrl = process.env.REACT_APP_WILDFIRE_PORTAL_URL;
    let links: IHeaderBarLink[] = [];
    if (process.env.REACT_APP_LINKS) {
        links = JSON.parse(process.env.REACT_APP_LINKS);
    } else {
        console.error("Unset environment variable: links");
    }

    function onClickSignOut() {
        if (!auth.isLoading && auth.isAuthenticated) {
            auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
        }
    }
    React.useEffect(() => {
        if (
            location.pathname !== "" &&
            location.pathname.includes("/flightReportDetail")
        ) {
            setBackground(true);
        } else {
            setBackground(false);
        }
    }, [location.pathname]);

    return (
        <>
            <div className="wrapper">
                <HeaderBar
                    logoUrl={logoUrl ?? ""}
                    headerTitle={headerTitle}
                    isAuthenticated={true}
                    links={links}
                    profileName={auth.user?.profile.name ?? ""}
                    onSignout={onClickSignOut}
                />

                <div
                    className={
                        isBackground === true
                            ? "row container detail-Container"
                            : "row container"
                    }
                >
                    <div className="content col-12">
                        <Routes>
                            <Route
                                index
                                element={
                                    <ProtectedRoute
                                        requiredRoles={["p_Aviat_FlightRpt_R"]}
                                    >
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="dashboard"
                                element={
                                    <ProtectedRoute
                                        requiredRoles={["p_Aviat_FlightRpt_R"]}
                                    >
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            {/* <Route path="/" element={<Dashboard />} />
                            <Route path="/dashboard" element={<Dashboard />} /> */}

                            <Route
                                path="/flightReportDetail/:id"
                                element={
                                    <ProtectedRoute
                                        requiredRoles={["p_Aviat_FlightRpt_R"]}
                                    >
                                        <FlightReportDetail />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/flightReportDetail"
                                element={
                                    <ProtectedRoute
                                        requiredRoles={["p_Aviat_FlightRpt_R"]}
                                    >
                                        <FlightReportDetail />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/logged-out" element={<LoggedOut />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                </div>

                <Toast></Toast>
            </div>
        </>
    );
};

export default Layout;
